import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Uue pakkumise lisamine", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "row p-3" }
const _hoisted_5 = { class: "col-12 text-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "row p-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 p-2" }, "Toote nimi", -1)
const _hoisted_9 = { class: "col-8 p-2" }
const _hoisted_10 = { class: "row p-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 p-2" }, "Triipkood", -1)
const _hoisted_12 = { class: "col-8 p-2" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Toote nimi", -1)
const _hoisted_16 = { class: "form-group row p-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Triipkood", -1)
const _hoisted_18 = { class: "col-8 p-2" }
const _hoisted_19 = { class: "input-group mb-3" }
const _hoisted_20 = { class: "input-group-append" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-qr-code-scan" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "form-group row p-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 p-2 control-label" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Toote pilt")
], -1)
const _hoisted_26 = { class: "col-8 p-2" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Kategooria", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Pood", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Hind", -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1)
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = { class: "col-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filetype-xml" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_barcode_scanner = _resolveComponent("barcode-scanner")!
  const _component_upload_image = _resolveComponent("upload-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    (_ctx.errorMsg != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.id !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.getProductImageByBarcode(_ctx.getProduct().barcode),
                alt: "",
                height: "164"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getProduct().name), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getProduct().barcode), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "col-8",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.barcode) = $event)),
                  type: "text",
                  class: "form-control",
                  "aria-label": "triipkood"
                }, null, 512), [
                  [_vModelText, _ctx.barcode]
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showScanner=!_ctx.showScanner)),
                    type: "button"
                  }, _hoisted_22)
                ])
              ]),
              (_ctx.showScanner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_barcode_scanner, {
                      qrbox: 100,
                      fps: 10,
                      onResult: _ctx.onScan
                    }, null, 8, ["onResult"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_upload_image)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryId) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryList(), (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.id,
                  value: option.id
                }, _toDisplayString(option.name), 9, _hoisted_29))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.categoryId]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _withDirectives(_createElementVNode("select", {
        class: "col-8",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shopId) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getShopList(), (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.id,
            value: option.id
          }, [
            _createTextVNode(_toDisplayString(option.name) + " ", 1),
            (option.distance)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "   " + _toDisplayString(_ctx.distanceUtil.round(option.distance)) + "km", 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_32))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.shopId]
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "col-8",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.price) = $event)),
        style: {"width":"100px"}
      }, null, 512), [
        [_vModelText, _ctx.price]
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("input", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitClicked())),
            type: "submit",
            value: "Lisa pakkumine",
            class: "btn btn-primary"
          })
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToImports()))
          }, _hoisted_41)
        ])
      ])
    ])
  ], 64))
}